import SearchIcon from '@mui/icons-material/SearchOutlined';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import React from 'react';

import Button from '@/components/Button';

interface SearchInputProps {
  buttonText?: string;
  placeholder: string;
  value?: string;
  error?: boolean;
  helperText?: string;
  handleKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sx?: any;
}

const CssTextField = styled(TextField)(({ theme }) => ({
  '& label.Mui-focused': {
    color: theme.palette.primary.main,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: theme.palette.primary.main,
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
    },
    '&:hover fieldset': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
    },
  },
}));

const SearchInput = ({
  buttonText,
  placeholder,
  value,
  error,
  helperText,
  handleKeyPress,
  onChange,
  onClick,
  sx,
}: SearchInputProps) => {
  return (
    <SearchBox>
      <CssTextField
        type="text"
        placeholder={placeholder}
        value={value}
        error={error}
        helperText={helperText}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        variant="outlined"
        onChange={onChange}
        onKeyDown={handleKeyPress}
        sx={{ width: { sm: '100%', md: '50%', lg: '60%' }, height: 'auto', ...sx }}
      />
      <Button variant="contained" onClick={onClick} size="medium">
        {buttonText}
      </Button>
    </SearchBox>
  );
};

export default SearchInput;

const SearchBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
  gap: '2rem',
  width: '65%',
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
    width: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    width: '100%',
    gap: '0.5rem',
  },
}));
